module.exports = __webpack_public_path__ + "static/img/main.2363915.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/OBDUCTION/bottom/part1/main.jpg
// module id = BG6q
// module chunks = 0